import About from "../_.segments/About";
import Cards from "../_.segments/Cards";
import Hero from "../_.segments/Hero";
import Skills from "./Skills";
import { LoaderFunctionArgs, json } from "@remix-run/node";
import i18next from "~/utils/localization/i18next.server";
import { getDesigners, getReviews, getSkills } from "~/api/base.server";
import OurDesigners from "./OurDesigners";
import Reviews from "../_.segments/Reviews";
import NeedHelpWithBtns from "~/components/NeedHelpWithBtns";
import { useState } from "react";
import CreateDesignerForm from "./CreateDesignerForm";
import { useTranslation } from "react-i18next";
import { handle } from "../_.segments/route";
import { useLoaderData } from "@remix-run/react";
import { localeAttr } from "~/utils/helper";
import useHost from "~/utils/hooks/useHost";

export async function loader({ request }: LoaderFunctionArgs) {
  const [locale, designers, reviews, skills] = await Promise.all([
    i18next.getLocale(request),
    getDesigners({ pagination: { limit: 20 } }),
    getReviews({ pagination: { limit: 20 } }),
    getSkills({
      pagination: { limit: 20 },
      filters: { websitePage: { $eq: "designers" } },
    }),
  ]);

  return json({ locale, designers, reviews, skills });
}

export default function Customers() {
  const [displayForm, setDisplayForm] = useState(false);
  const { skills, locale } = useLoaderData<typeof loader>();

  const { t } = useTranslation(handle.i18n);
  const host = useHost();

  return (
    <div>
      <Hero
        img="/images/segments/designers2.jpeg"
        title={t("designers.title")}
        onRegisterClick={() => setDisplayForm(true)}
      />
      <About title="designers" numbers={[t("11"), t("532"), t("179")]} />
      <Cards segment="designers" />
      <Skills
        items={
          skills?.map((skill) => ({
            image: host + skill.attributes.logo.data.attributes.url,
            title: localeAttr(skill.attributes, "name", locale),
          })) ?? []
        }
        title="designers"
      />
      <OurDesigners />
      <Reviews />
      <div className="cont min-w-full">
        <NeedHelpWithBtns
          className="mt-20"
          registerOnClick={() => {
            setDisplayForm(true);
          }}
        />
      </div>
      {displayForm && <CreateDesignerForm setDisplayForm={setDisplayForm} />}
    </div>
  );
}
